export default {
  API_ENDPOINT: 'https://maple-minister-95148.herokuapp.com/api',
  TOKEN_KEY: process.env.TOKEN_KEY,
};